import { AppSwitcher } from '@atlaskit/atlassian-navigation';
import Popup from '@atlaskit/popup';
import { Severity } from '@sentry/browser';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { addBreadcrumb, BreadcrumbCategory } from '../../../../sentry';
import { switcherMessages as messages } from '../../../common/intl/switcher';

import SwitcherMenu from './SwitcherMenu';

const NavSwitcherButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    addBreadcrumb({
      category: BreadcrumbCategory.UiClick,
      level: Severity.Info,
      message: isOpen ? 'atlassianSwitcher closed' : 'atlassianSwitcher opened',
      type: 'ui',
    });
    setIsOpen(!isOpen);
  };

  const onClose = () => {
    addBreadcrumb({
      category: BreadcrumbCategory.UiClick,
      level: Severity.Info,
      message: 'atlassianSwitcher closed',
      type: 'ui',
    });
    setIsOpen(false);
  };

  return (
    <Popup
      placement="bottom-start"
      content={() => <SwitcherMenu />}
      isOpen={isOpen}
      testId="nav__switcher-menu"
      onClose={onClose}
      trigger={triggerProps => (
        <AppSwitcher
          testId="switcher-btn"
          tooltip={<FormattedMessage {...messages.switcher} />}
          {...triggerProps}
          isSelected={isOpen}
          onClick={onClick}
        />
      )}
    />
  );
};

export default NavSwitcherButton;
